<template>
  <!-- ERROS NA TELA -->
  <v-bottom-sheet v-model="janelaErrosnaTela" inset>
    <!-- <v-sheet color="transparent"> -->
    <v-alert
      v-for="(item, key) in errosNaTela"
      :key="key"
      elevation="2"
      :type="item.tipo"
      transition="scale-transition"
      prominent
    >
      {{ item.descricao }} <br />
      {{ item.origem }}
    </v-alert>
    <!-- </v-sheet> -->
  </v-bottom-sheet>
</template>

<script>
export default {
  name: "alerta-dialogo",
  data() {
    return {
      janelaErrosnaTela: false,
      errosNaTela: [],
    };
  },
  // props: {
  //   janelaErrosnaTela: Boolean,
  //   errosNaTela: {
  //     type: Object
  //   }
  // },
  methods: {
    abrir(descricaoErro, origemErro, tipo) {
      this.errosNaTela.splice(0);
      this.errosNaTela.push({
        descricao: descricaoErro,
        origem: origemErro,
        tipo: tipo,
        timer: setTimeout(() => {
          this.errosNaTela.splice(0, 1);
        }, this.$tempoErrosNaTela),
      });
      this.janelaErrosnaTela = true;
    },
  },
  mounted() {},
};
</script>
